<template>
  <div :class="['nav',center?'center':'']" v-if="navList && navList.length">
    <span @click="changeNavCallBack(index)" :class="['cursor',navIndex==index?'active':'']" v-for="(item,index) in navList" :key="index">{{item.name}}</span>
  </div>
</template>

<script>
export default {
  name: 'navComp',
  props: ['navList','navIndex','center'],
  methods: {
    changeNavCallBack (index) {
      this.$emit('changeNavCallBack',index)
    }
  }
}
</script>

<style lang="scss" scoped>
.nav {
  padding-bottom: 14px;
  // border-bottom: 1px solid #DFE2E6;
  span {
    font-size: 16px;
    font-weight: bolder;
    color: #A1AAB3;
    line-height: 24px;
    &.active {
      color: #1F262E;
      position: relative;
      &::after {
        content:'';
        position: absolute;
        top: 28px;
        left: 50%;
        transform: translateX(-50%);
        width: 12px;
        height: 3px;
        background: #1F262E;
      }
    }
  }
}
.center {
  display: flex;
  justify-content: space-between;
  padding: 16px 16px 0px;
  span {
    color: #A1AAB3;
    margin-right: 0;
    &.active {
      color: #1F262E;
      &::after {
          // content:'';
          // position: absolute;
          // top: 40px;
          // left: 50%;
          // transform: translateX(-50%);
          // width: 24px;
          // height: 3px;
          background: #1F262E;
        }
    }
  }

}

</style>